import React from "react";
import {ProcessingButtonAnimationTextStyled, ProcessingButtonContainerStyled, ProcessingButtonStyled} from "./ProcessingButton.style";
import TouchEffect from "../TouchEffect/TouchEffect";
import {SvgMoreButtonArrowIcon} from "../../pages/result/ResultPage";
import Creative from "../../photolab/Creative";

const maxProgressPercent = 100;

export default class ProcessingButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            progressPercent: 100
        }

        this.processingTookSecondsApprox = 20;
        this.progressUpdateTimer = null;
    }

    componentDidMount() {
        this.handleStartProgressUpdate();
    }

    componentWillUnmount() {
        this.handleStopProgressUpdate();
    }

    componentDidUpdate() {
        if (!this.props.creative) {
            return;
        }

        if (this.props.creative.isFinished) {
            this.handleStopProgressUpdate();
        } else if (!this.props.creative.isDummy) {
            this.handleStartProgressUpdate();
        }
    }

    handleStartProgressUpdate = () => {
        this.progressUpdateTimer = requestAnimationFrame(this.handleProgressUpdate);
    };

    handleStopProgressUpdate = () => {
        cancelAnimationFrame(this.progressUpdateTimer);
    }

    handleProgressUpdate = () => {
        if (!this.props.creative) {
            return;
        }

        const secondsPassedFromStart = (Date.now() - this.props.creative.getExtra(Creative.EXTRA_STARTED_AT)) / 1000;

        if (secondsPassedFromStart > 10) {
            this.processingTookSecondsApprox = Math.min(150, this.processingTookSecondsApprox + 0.005);
        }

        let progressPercent = 100 - ((secondsPassedFromStart / this.processingTookSecondsApprox) * maxProgressPercent);
        this.setState({progressPercent: Math.max(progressPercent, 0)});
        if (progressPercent >= maxProgressPercent || this.props.creative.isFinished) {
            this.handleStopProgressUpdate();
        }
    };

    renderText = () => {
        return <p>
            {this.props.text}
            <span className="dots-container">
                <span>.</span><span>.</span><span>.</span>
            </span>
        </p>
    }

    render() {
        const {progressPercent} = this.state;
        const {creative, onClick} = this.props;

        return (
            <ProcessingButtonContainerStyled>
                {creative && creative.isFinished && <img src="/assets/images/icon-fire.png" alt="" />}
                <ProcessingButtonStyled className={creative && creative.isPending ? "anim" : ""} onClick={onClick}>
                    {this.renderText()}
                    {creative && creative.isFinished && <SvgMoreButtonArrowIcon />}
                    <ProcessingButtonAnimationTextStyled style={{
                        WebkitMaskImage: `linear-gradient(to left, transparent ${progressPercent}%, #ccc ${progressPercent}%`,
                        maskImage: `linear-gradient(to left, transparent ${progressPercent}%, #ccc ${progressPercent}%`,
                        display: creative && creative.isPending ? "flex" : "none"
                    }}>
                        {this.renderText()}
                    </ProcessingButtonAnimationTextStyled>
                    <TouchEffect />
                </ProcessingButtonStyled >
            </ProcessingButtonContainerStyled>
        )
    }
}